<template>
  <div class="Reward" :class="{ five: level % 5 === 0,'five-pro': level % 5 === 0 && isPro }">
    <div class="Reward-box" 
        :class="{'five-box': level % 5 === 0}"
        @click="debounce(handleRewardClick, 200)()">
      <!-- 奖励 -->
      <img class="Reward-box-icon" :src="image_url" v-if="image_url!==''" />
      <!-- 数量 -->
      <div class="Reward-box-number longTouch">{{ count }}</div>
      <!-- 蒙版 已领取状态 -->
      <div
        v-if="cur_reward_state === REWARD_STATE.CLAIMED"
      >
        <!-- 领取动画 -->
        <AnimCheck 
          v-if="animCheckShow"
          @closeAnim="animCheckHandle"
          :isShow="animCheckShow"
          :playEffect="animAudioPlay"
        />
        <!-- 动画播放结束 -->
        <div class="Reward-box-mengban"
             v-show="!animCheckShow && animState == 0">
          <img
            :src="require('@/assets/images/YuliApp/weeklyTask/btn_task_yes2.svg')"
          />
        </div>
      </div>

      <!-- 未领取状态 -->
      <div
        class="Reward-box-unClaimed"
        :style="{display: `${isPro && !isLockUpgraded?'none':''}`}"
        v-if="cur_reward_state === REWARD_STATE.UNCLAIMED"
      >
        <img
          :src="require('@/assets/images/YuliApp/weeklyTask/gantanhao.svg')"
        />
      </div>

      <!-- 未解锁 -->
      <div
        class="Reward-box-unLocked"
        v-if="cur_reward_state === REWARD_STATE.NOT_UNLOCKED || (isPro && !isLockUpgraded)"
      >
        <img :src="require('@/assets/images/YuliApp/weeklyTask/white_lock.svg')" />
      </div>
    </div>
    <div class="Reward-level longTouch" 
        :class="{'five-level': level % 5 === 0}"
        v-if="!isPro">
      lv.{{ level }}
    </div>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, getCurrentInstance } from "vue";
import { REWARD_TYPE, ERROR_TEXT } from "@/constants/enums";
import audioManager from "@/utils/audioManager";
import {
  getTaskReward,
  postRewardClaim,
  postExpClaim,
} from "@/api/weeklyTask.js";
import appBridging from "@/utils/appBridging.js";
import _ from "lodash";
import { TOAST_TYPE } from "../../../../../Toast/index.vue";
import AnimCheck from "../AnimCheck";

export default {
  components: {
    AnimCheck
  },
  props: {
    level: {
      type: Number,
      default: 0,
    },
    state: {
      type: Number,
      default: 0,
    },
    image_url: {
      type: String,
      default: "",
    },
    count: {
      type: Number,
      default: 1,
    },
    reward_item: {
      type: Object,
      default: null,
    },
    id: {
      type: String,
      default: "",
    },
    period_id: {
      type: String,
      default: "",
    },
    isClaiming: {
      type: Boolean,
      default: false,
    },
    isPro: {
      type: Boolean,
      default: false
    },
    isLockUpgraded: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    level: {
      handler(value) {
        // console.log("value",value)
        this.cur_reward_level = value;
      },
      immediate: true,
      deep: true,
    },
    state: {
      handler(value) {
        this.cur_reward_state = value;
      },
      immediate: true,
      deep: true,
    },
    reward_item: {
      handler(value) {
        this.cur_reward_item = value;
        if(value?.rewarding){
          // 监听处于领奖中状态的物品
          // console.log('reward进入监听',value?.level);
          this.animCheckShow = true;
          this.animState = 1;
        }else{
          this.animCheckShow = false;
          this.animState = 0;
        }
        if(value?.playEffect){
          // console.log('判断是否播放音频 enter');
          //判断是否播放音频
          this.animAudioPlay = true;
        }else this.animAudioPlay = false;
      },
      immediate: true,
      deep: true,
    },
    isClaiming: {
      handler(value) {
        this.claimingState = value;
      },
      immediate: true,
      deep: true,
    },
    isLockUpgraded: {
      handler(value) {
        this.is_upgraded = value;
      },
      immediate: true,
      deep: true,
    }
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();

    const { level, state, reward_item, id, period_id } = props;
    const REWARD_STATE = ref(REWARD_TYPE);
    const cur_reward_state = ref(0);
    const cur_reward_level = ref(0);
    const cur_reward_item = ref(null);
    const claimingState = ref(false);
    const is_upgraded = ref(false);
    const animCheckShow = ref(false);
    const animAudioPlay = ref(false);
    const animState = ref(0); //动画播放状态 0-动画播放关闭，1-动画播放开启
    /**
     * 防抖
     * @param fun 防抖函数
     * @param delay 延迟时间
     * @param timerid 延时id [可选参数] 若传参将固定timer的id
     */
    function debounce(fun, delay, timerid) {
      return function (args) {
        let that = this;
        let _args = args;
        let timer = timerid || fun.id;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fun.call(that, _args);
        }, delay);
      };
    }

    /**
     * 处理领取奖励
     * state为1表领取成功
     * state为2表已领取
     * state为0表还没完成任务
     */
    const handleRewardClick = async () => {
      if (claimingState.value) {
        return;
      }
      // 是否升级pro判断
      if(proxy.isPro && !is_upgraded.value){
        emit(
          "claiming", 
          "unpro",
          cur_reward_item.value
        );
        return;
      }
      emit("claiming", true);
      audioManager.playEffect("bubble");

      //未领取
      if (cur_reward_state.value === REWARD_TYPE.UNCLAIMED) {
        proxy.$loading.show();

        const { result, state, current_holding, code } = await requestDrawReward();

        proxy.$loading.hide();

        if (result && state === 1) {
          localStorage.setItem("prop_id", cur_reward_item.value.prop_id);
          localStorage.setItem("current_holding", current_holding);

          emit(
            "rewardClick",
            {
              level: reward_item?.level,
              reward_type: reward_item?.reward_type
            },
            cur_reward_state.value,
            cur_reward_item.value
          );

          animState.value = 1;
          cur_reward_state.value = REWARD_TYPE.CLAIMED;

          setTimeout(() => {
            audioManager.playEffect("get_token");
          }, 200);
        } else {
          if(code == 400011){
            emit("claiming", code);
            return;
          }else {
            emit("claiming", 'error');
          }
          emit("claiming", false);
        }
        //未解锁、已领取
      } else {
        emit(
          "rewardClick",
          {
            level: reward_item?.level,
            reward_type: reward_item?.reward_type
          },
          cur_reward_state.value,
          cur_reward_item.value
        );
      }
    };

    /**
     * 请求领取奖励
     */
    const requestDrawReward = () => {
      const param = {
        level: cur_reward_level.value,
        reward_type: proxy.isPro ? 2 : 1,//根据isPro判断领取类型，2是pro，1是基础
        period_id: period_id,
      };
      return postRewardClaim(param)
        .then((res) => {
          const state = _.get(res, "data.state", 0);
          const current_holding = _.get(res, "data.current_holding", 0);
          appBridging.handleRefreshNativeCache('V1GetUProps');
          appBridging.handleRefreshNativeCache('V1GetChips');
          return {
            result: true,
            state: state,
            current_holding: current_holding,
            code: 200,
          };
        })
        .catch((error) => {
          console.log(error);
          const code = error?.response?.data?.code;
          
          return {
            result: false,
            state: 0,
            current_holding: cur_reward_item.value.current_holding,
            code: code,
          };
        });
    };

    /**
     * 打勾动画监听
     */
    const animCheckHandle = (sign) => {
      animCheckShow.value = false;
      animState.value = 0;
      if(sign == 'next'){
        // console.log('进入next节点');
        emit(
          "rewardClick",
          'next'
        );
      }
    }

    return {
      REWARD_STATE,
      cur_reward_level,
      cur_reward_state,
      cur_reward_item,
      handleRewardClick,
      animCheckHandle,
      debounce,
      claimingState,
      is_upgraded,
      animCheckShow,
      animState,
      animAudioPlay,
    };
  },
};
</script>

<style lang="less" scoped>
//阻止长按操作
.longTouch {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}

.Reward {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  width: 52px;
  height: 100%;
  margin-top: 7px;
  margin-bottom: 10px;
  &-box {
    position: relative;
    width: 52px;
    height: 52px;
    background: url("~@/assets/images/YuliApp/weeklyTask/reward_block_bg.svg")
      no-repeat top left;
    background-size: 100% 100%;

    // margin-bottom: 4px;
    &-icon {
      width: 43px;
      height: 43px;
      object-fit: cover;
    }
    &-number {
      position: absolute;
      z-index: 10;
      // bottom: 1.8px;
      margin-left: 49%;
      transform: translate(-50%, 0);
      // width: 89%;
      height: 14.73px;
      // background: url("~@/assets/images/YuliApp/weeklyTask/reward_block_bg_2.svg")
      //   no-repeat top left;
      // background-size: 100% 100%;
      border-radius: 0 0% 4px 4px;
      bottom: 0;
      left: 1px;
      width: 52px;
      background: rgba(0, 0, 0, 0.4);
      color: rgba(255, 255, 255, 0.9);
      font-size: 12px;
      font-weight: 400;
      font-family: "PingFang HK";
      text-align: center;
      line-height: 15px;
      letter-spacing: 0.72px;
    }
    // 已领取
    &-mengban {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      width: 100%;
      height: 100%;
      border-radius: 4px;
      // background: url("~@/assets/images/YuliApp/weeklyTask/reward_mengban.svg")
      //   no-repeat top left;
      // background-size: 100% 100%;
      background: rgba(0, 0, 0, 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 32px;
        height: 32px;
      }
    }

    //未领取
    &-unClaimed {
      position: absolute;
      right: -3px;
      top: -3px;
      width: 12.8px;
      height: 12.8px;
      opacity: 1;
      background: rgba(222, 75, 75, 1);
      border-radius: 50%;
      img {
        position: absolute;
        // left: 4.32px;
        // bottom: 3.2px;
        // width: 11.2px;
        // height: 12.8px;
        left: 2.32px;
        bottom: 3.2px;
        width: 11.2px;
        height: 12.8px;
        scale: 1.2;
      }
    }

    //未解锁
    &-unLocked {
      position: absolute;
      top: -4px;
      right: -5px;
      width: 16px;
      height: 16px;
      img {
        position: absolute;
        top: 5px;
        left: -5px;
        width: 100%;
        height: 100%;
      }
    }
  }
  &-level {
    // height: 16.79px;
    // // margin-top: 4px;
    // color: rgba(255, 255, 255, 1);
    // font-size: 12px;
    // font-weight: 500;
    // font-family: "PingFang HK";
    // text-align: center;
    // line-height: 16.79px;
    // letter-spacing: 0.72px;
    width: 20px;
    height: 14px;
    opacity: 1;
    // color: #5058a4ff;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    font-family: "PingFang HK";
    text-align: center;
    line-height: 14.4px;
    letter-spacing: 0.72px;
    position: absolute;
    top: -23px;
    left: 15px;
    z-index: 14;
  }
}
.five {
  // margin-top: -5px;
  height: 100%;
  box-sizing: border-box;
  // padding-top: 5px;
  width: 67px;
  margin: unset;
  // background: url("~@/assets/images/YuliApp/weeklyTask/bg_lv5@2x.png") no-repeat
  //   top left;
  // background-size: 100% 100%;
  // background: linear-gradient(180deg, #d8e8fa 0%, #d7eafb 100%);
  background: rgba(179, 195, 252, 0.6);
  &-box{
    margin-top: 7px;
  }
  &-pro{
    // background: linear-gradient(180deg, #fff0a6 0%, #fff0a6 100%);
    border-radius: 2px;
    border: 0.5px solid rgba(255, 255, 255, 0.8);
    border-bottom: unset;
    background: linear-gradient(180deg, rgb(255, 243, 181) 0%, rgb(143, 181, 255) 100%);
  }
  &-level{
    top: -16px;
    left: 21px;
  }
  .Reward-box {
  }
  // .Reward-level {
  //   margin-top: 2.3px;
  // }
}
</style>
